<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <div *ngIf="loader" class="loader"
    style="text-align: center !important;font-size: 18px; margin-top: 20px;">
    Loading, please wait...
</div>
    <!-- Header Block -->
    <div class="container-fluid">
      <div class="container-fluid my-3">
        <div class="top-card">
          <div class="row w-100 mx-auto d-flex">
            <div class="col-sm-12 col-md-12 col-lg-9 pl-4">
              <!-- <img class="logo-top" src="../../assets/images/logo-M (1).png" /> -->
              <span class="">Sale Volume Compare</span>
            </div>
          </div>
        </div>
      </div>
      <div class="main-tablefilers">
        <div class="tablefilters">
            <div class="dropdown" style="margin: 10px 0px;">
              <p-dropdown 
              [options]="sourceDropdownOptions" 
              [(ngModel)]="selectedSource"
              (ngModelChange)="onDropdownChange()"
              [autoWidth]="false"
              [filter]="true"
              filterBy="label">
          </p-dropdown>
            </div>
        </div>
    </div>

    <div class="table-responsive" *ngIf="flattenedData && flattenedData.length > 0">
        <table class="table table-striped table-bordered text-center" style="float: left">
            <thead>
              <tr>
                <th>Brand Name</th>
                <th>Fill Volume</th>
                <th>NDA</th>
                <th>Strength</th>
                <th>User Email</th>
                <th>Year4 DB</th>
                <th>Year4 USER</th>
                <th>Year4 Percentage</th>
                <th>Year5 USER</th>
                <th>Year5 DB</th>
                <th>year5 Percentage</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let items of flattenedData; let i= index">
                <td>{{items["Brand Name"] || 'N/A'}}</td>
                <td>{{items["Fill_Volume"] ?  items["Fill_Volume"] : 'N/A' }}</td>
                <td>{{items["NDA"]|| 'N/A'}}</td>
                <td>{{items["Strength"] || 'N/A'}}</td>
                <td>{{items["user_email"] || 'N/A'}}</td>
                <td>{{items["year4_DB"]|| 'N/A'}}</td>
                <td>{{items["year4_USER"]|| 'N/A'}}</td>
                <td>{{items["year4_pct_change"]|| 'N/A'}}</td>
                <td>{{items["year5_USER"]|| 'N/A'}}</td>
                <td>{{items["year5_DB"]|| 'N/A'}}</td>
                <td>{{items["year5_pct_change"]|| 'N/A'}}</td>
              </tr>
            </tbody>
          </table>
      </div>
    </div>
  </div>